import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import PrivateRoute from "../components/PrivateRoute";
import LoginContainer from "../containers/LoginContainer";
import DashboardContainer from "../containers/DashboardContainer";
import MenuContainer from "../containers/MenuContainer";
import DataFolderContainer from "../containers/DataFolderContainer";
// import DocumentRegisterContainer from '../containers/DocumentRegisterContainer';
import DetailSearchContainer from "../containers/DetailSearchContainer";
import DocumentRegisterContainer from "../containers/DocumentRegisterContainer";
import DocumentViewContainer from "../containers/DocumentViewContainer";
import DocumentEditContainer from "../containers/DocumentEditContainer";
import "../App/App.css";

const App = () => {
  const location = useLocation();

  const hideMenu =
    location.pathname === "/login" ||
    location.pathname.includes("/detailsearch") ||
    location.pathname.includes("/register") ||
    location.pathname.includes("/view") ||
    location.pathname.includes("/edit");

  return (
    <div className="main-container">
      {!hideMenu && <MenuContainer />}
      <Routes>
        <Route path="/login" element={<LoginContainer />} />

        <Route
          path="/"
          element={
            <PrivateRoute>
              <DashboardContainer />
            </PrivateRoute>
          }
        />

        <Route
          path="/department/:deptId"
          element={
            <PrivateRoute>
              <DataFolderContainer />
            </PrivateRoute>
          }
        />

        <Route
          path="/department/:deptId/folder/:folderId"
          element={
            <PrivateRoute>
              <DataFolderContainer />
            </PrivateRoute>
          }
        />

        <Route
          path="/department/:deptId/folder/:folderId/register"
          element={
            <PrivateRoute>
              <DocumentRegisterContainer />
            </PrivateRoute>
          }
        />

        <Route
          path="/department/:deptId/detailsearch"
          element={
            <PrivateRoute>
              <DetailSearchContainer key={window.location.pathname} />
            </PrivateRoute>
          }
        />

        <Route
          path="/department/:deptId/folder/:folderId/detailsearch"
          element={
            <PrivateRoute>
              <DetailSearchContainer key={window.location.pathname} />
            </PrivateRoute>
          }
        />

        <Route
          path="/viewId/:docId/view"
          element={
            <PrivateRoute>
              <DocumentViewContainer />
            </PrivateRoute>
          }
        />

        <Route
          path="/viewId/:docId/edit"
          element={
            <PrivateRoute>
              <DocumentEditContainer />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
};

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
